import type { PageProps } from 'gatsby';
import React from 'react';

import Drilldown from '@views/Records/Routines/Drilldown';

export default function RoutinesPage({ params }: PageProps) {
  return <Drilldown {...params} />;
}
